import { render, staticRenderFns } from "./Refuetype.vue?vue&type=template&id=28a8831c&scoped=true"
import script from "./Refuetype.vue?vue&type=script&lang=js"
export * from "./Refuetype.vue?vue&type=script&lang=js"
import style0 from "./Refuetype.vue?vue&type=style&index=0&id=28a8831c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a8831c",
  null
  
)

export default component.exports